<template lang="pug">
  //v-layout.calendar-nav
  //  v-flex(xs2 sm2 md2 lg2 )
  //    v-btn(fab icon :disabled="!isBackButtonEnabled" :large="showLargeButton" )
  //      v-icon(color="teal" large @click="onPrevWeek") fas fa-chevron-circle-left
  //
  //  v-flex(xs10 sm10 md10 lg10 )
  //    v-layout
  //      v-flex {{weekLabel}}
  //      v-flex {{weekRange}}
  //  v-flex(xs2 sm2 md2 lg2 )
  //    v-btn(fab text icon )
  //      v-icon(color="teal" large @click="onNextWeek")  fas fa-chevron-circle-right

  v-row.align-center.text-center
    v-col.flex-shrink-1.flex-grow-0
      v-btn(fab icon :disabled="!isBackButtonEnabled" :large="showLargeButton")
        v-icon(color="teal" @click="onPrevWeek") fas fa-chevron-circle-left
    v-col.flex-shrink-0.flex-grow-1.pa-0
      v-row.pt-3(no-gutters)
        v-col {{ weekLabel }}
        v-col {{ weekRange }}
    v-col.flex-shrink-1.flex-grow-0
      v-btn(fab icon :large="showLargeButton")
        v-icon(color="teal" @click="onNextWeek")  fas fa-chevron-circle-right

</template>

<script lang="ts">
import Vue from 'vue'
import moment from "moment";
import {Component, Prop} from "vue-property-decorator";

@Component({
  components: {}
})
export default class CalendarNav extends Vue {

  @Prop({type: String, required: true}) isoWeek!: string
  @Prop({type: Boolean, default: true}) allowNavigationToPast!: boolean

  // selected_week: number | null = null
  // current_week: number | null = null
  // disable_prev_button: boolean = true
  // selected_from: string | null = null
  // selected_to: string | null = null

  get weekLabel (): string {
    return `${moment(this.isoWeek).format('W')}. ${this.$t('dailymenuPage.weekname')}`
  }

  get weekRange (): string {
    const start = moment(this.isoWeek)
    const end = start.clone().add(1, 'week')

    return `${start.format('D.M')} - ${end.format('D.M')}`
  }

  /*onNextWeek(): void {

    if (this.selected_week) {
      this.selected_week++
      this.disable_prev_button = false
    }

  }

  onPrevWeek(): void {

    if (this.selected_week && this.current_week) {
      let prev_week = this.selected_week - 1

      if (prev_week >= this.current_week) {
        this.selected_week = prev_week
      }

      if (prev_week == this.current_week) {
        this.disable_prev_button = true
      }
    }

  }*/

  get isBackButtonEnabled (): boolean {
    if (this.allowNavigationToPast) {
      return true
    } else {
      const currentWeekStart = moment().startOf('isoWeek')
      const previousWeekStart = moment(this.isoWeek).subtract(1, 'week').startOf('isoWeek')

      return !previousWeekStart.isBefore(currentWeekStart)
    }
  }

  get showLargeButton (): boolean {
    return !this.$vuetify.breakpoint.xs
  }

  onNextWeek (): void {
    const from = moment(this.isoWeek).add(1, 'week').isoWeekday(1).format("Y-MM-DD")
    const to = moment(this.isoWeek).add(1, 'week').isoWeekday(7).format("Y-MM-DD")
    this.$emit('update:isoWeek', moment(this.isoWeek).add(1, 'week').format('GGGG[W]WW'))
    // this.loadWeek(from, to)
  }

  onPrevWeek (): void {
    this.$emit('update:isoWeek', moment(this.isoWeek).subtract(1, 'week').format('GGGG[W]WW'))

  }

  /*loadWeek(from: string, to: string): void {
    console.log("LOAD WEEK")
    // this.$emit("loadWeek", moment(from, 'YYYY-MM-DD').toDate(), moment(to, 'YYYY-MM-DD').toDate())
    this.$store.dispatch(AVAILABLE_DAILY_MENU, {from: from, to: to})
  }*/

  /*@Watch('selected_week')
  watchSelected_week(newVal: number): void {
    if (newVal) {

      if (this.selected_week && this.current_week) {

        const from_date = Moment().week(newVal).isoWeekday(1);
        const to_date = Moment().week(newVal).isoWeekday(7);
        this.selected_from = from_date.format("D.M")
        this.selected_to = to_date.format("D.M")

        const from_date_formatted = from_date.format("Y-MM-DD")
        const to_date_formatted = to_date.format("Y-MM-DD")
        this.loadWeek(from_date_formatted, to_date_formatted)

      }

    }
  }*/

  /*mounted(): void {
    let weeknumber = Moment().week();
    this.current_week = weeknumber
    this.selected_week = this.current_week
  }*/
}
</script>

<style lang="stylus" scoped>

.calendar-nav {
  text-align: center;
  align-items: center;
  font-size: 1.3em
}


@media screen and (max-width: 1400px) {
  .calendar-nav {
    font-size: 1.2em
  }
}
</style>
